/**
 * Generated by orval v8.12.2 🍺
 * Do not edit manually.
 * PEXIFY Backend
 * PEXIFY operating system backend — privately governed commerce ecosystem. M3 başlangıcı: FastAPI shell. Faz 1-6 schema RATIFIED; per-component CRUD + RBAC + audit emit + engines (M-AUDIT / M-WALLET / M-POLICY / M-NOTIF) coming.
 * OpenAPI spec version: 0.1.0
 */

export type MessagingConversationStatus = typeof MessagingConversationStatus[keyof typeof MessagingConversationStatus];


export const MessagingConversationStatus = {
  open: 'open',
  pending: 'pending',
  resolved: 'resolved',
  snoozed: 'snoozed',
} as const;
